
    import { Options, Vue } from 'vue-class-component';

    @Options({
        props: {
            number: [Number, String],
            contentClass: {
                type: [String, Object],
                default: 'ap-block',
            },
        },
    })
    export default class ApNumberBlock extends Vue {}
